export default {
  baseUrl: 'https://svc-b2b-expertfinder.apps.np.sdppcf.com/v1/b2b',
  configUrl: '/business-enterprise/expert-finder/config.json.html'
};



// WEBPACK FOOTER //
// ./src/config/config.fast.js